<template>
  <div class="product-dybamic">
    <Banner />
    <div class="search-container">
      <el-input
        placeholder="请输入产品名称"
        prefix-icon="el-icon-search"
        v-model="keyword"
        @input="getSystemsDynamic"
        clearable
      ></el-input>
    </div>
    <div class="product-container">
      <div v-for="(i, n) in 4" :key="n" class="line">
        <div v-for="(product, index) in productList[i-1]" :key="index" class="product-item">
          <a :href="product.system_url" target="_blank" v-trace-click="'n.3839.7341.0'">
            <div class="item-header">
              {{ product.alias_name==''? product.system_name:product.alias_name}}
              <img
                src="@/assets/icon/link.png"
                alt
              />
            </div>
          </a>
          <div
            class="item-body"
            style="overflow:auto"
            v-infinite-scroll="getDynamicsDetail.bind(this, product)"
            infinite-scroll-immediate="false"
            @mouseleave="scroll"
          >
            <div class="introduction">{{product.intro}}</div>
            <div class="information">
              <div class="introduction-item">
                <div class="introduction-item-name">版本号</div>
                {{ product.version }}
              </div>
              <div class="introduction-item">
                <div class="introduction-item-name">上线时间</div>
                {{ product.online_time_str }}
              </div>
              <div class="introduction-item">
                <div class="introduction-item-name">产品负责人</div>
                {{ product.create_name }}
              </div>
            </div>
            <ul class="item-content">
              <li v-for="x in product.content" :key="x">{{x}}</li>
            </ul>
            <div
              class="fill"
              style="height:20px;background-color:rgba(242, 246, 252, 1);margin-left:20px;margin-right:18px;"
            ></div>
            <div class="dynamics-list">
              <div
                v-for="(item, idx) in product.list"
                :key="index + '-' + idx"
                :data-id="item.id"
                class="list-item"
              >
                <div class="introduction-version time">{{ item.online_time_str }}</div>
                <div class="introduction-version">版本号{{ item.version }}</div>
                <div class="content">{{ item.content }}</div>
              </div>
            </div>
            <img src="@/assets/icon/loading.png" alt class="loading" v-if="product.load" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "./compoents/banner.vue";
export default {
  name: "product-dybamic",
  components: {
    Banner
  },
  data() {
    return {
      products: [],
      form: {
        system_key: "",
        page: 1,
        page_size: 5
      },
      keyword: "",
      count: "",
      productList: []
    };
  },
  created() {
    this.keyword = this.$route.query.key;
    this.getSystemsDynamic();
  },
  methods: {
    // @tracer("n.3839.7340.0") //vetur会报错但不影响使用
    scroll(event) {
      // mcTracer.click("n.3839.7340.0");
      const el = event.target;
      setTimeout(() => {
        el.scrollTop = 0;
      }, 500);
    },
    frame(el, num) {
      num--;
      el.scrollTop = el.scrollTop - 20;
      if (num > 0) {
        setTimeout(this.frame(el, num), 100);
      }
    },
    getDynamicsDetail(product) {
      if (product.total - 1 == product.list.length) return;
      product.page++;
      let params = {
        system_key: product.system_key,
        page: product.page,
        page_size: 5
      };
      product.load = true;
      _api.product.getDynamicsList(params).then(res => {
        product.load = false;
        product.list = product.list.concat(res.data.rows);
        product.total = Number(res.data.total);
        if (product.page == 1) {
          product.list.shift();
        }
        this.$forceUpdate();
      });
    },
    getSystemsDynamic() {
      this.productList = [];
      _api.product.getSystemsDynamic({ keyword: this.keyword }).then(res => {
        this.products = res.data;
        this.products.forEach(j => {
          j.content = j.content.split(/\r?\n/g);
        });
        this.products.forEach((i, index) => {
          i.page = 0;
          i.list = [];
          i.total = -1;
          i.load = false;
          if (!this.productList[index % 4]) this.productList[index % 4] = [];
          this.productList[index % 4].push(i);
          this.getDynamicsDetail(i);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-dybamic {
  width: 1200px;
  margin: 0 auto 300px auto;
  /deep/.el-input {
    width: 570px;
    height: 36px;
  }
  /deep/.el-input__inner {
    height: 36px !important;
  }
  /deep/.el-icon-search {
    margin-top: -2px !important;
  }
}
.search-container {
  margin: 20px 0;
  .serach-bt {
    height: 36px;
    padding: 9px 20px;
    margin-left: 20px;
  }
}
.product-container {
  display: flex;
}
.product-item {
  width: 285px;
  max-height: 686px;
  border-radius: 4px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(235, 238, 245, 1);
  background-color: #fff;
  z-index: 9;
  margin: 0 20px 20px 0;
  overflow: hidden;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  &:nth-child(4n) {
    margin-right: 0;
  }
  &:hover {
    border: 1px solid rgba(24, 144, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
  }
  .item-header {
    height: 40px;
    background-color: rgba(24, 144, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    cursor: pointer;
  }
  .item-body {
    height: 337px;
    transition: all 0.5s 0.5s;
    .introduction {
      margin: 20px 20px 0 20px;
      line-height: 22px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    &::-webkit-scrollbar {
      display: none;
    }
    &:hover {
      height: 608px;
    }
    &:hover .item-content {
      display: block;
      max-height: 1000px;
    }
    &:hover .introduction {
      display: block;
      height: auto;
    }
  }
  .information {
    margin: 20px;
    .introduction-item {
      display: flex;
      margin: 10px 0;
      &-name {
        width: 80px;
        height: 14px;
        line-height: 14px;
        color: rgba(144, 147, 153, 1);
        font-size: 14px;
        font-family: PingFangSC-Regular;
      }
    }
  }
  .item-content {
    width: 245px;
    max-height: 130px;
    min-height: 130px;
    transition: all 0.5s 0.5s;
    margin: 20px 20px 0 20px;
    padding: 20px 20px 0 12px;
    line-height: 22px;
    color: rgba(96, 98, 102, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    background-color: rgba(242, 246, 252, 1);
    overflow: hidden !important;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    li {
      overflow: hidden;
      list-style: inside;
    }
  }
}
.dynamics-list {
  margin-top: 40px;
  padding: 0 20px;
  .list-item {
    margin: 36px 0;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: -4px;
      top: 7px;
      width: 5px;
      height: 5px;
      border-radius: 4.5px;
      background-color: #1890ff;
      border: 2px solid #b5dbff;
    }
    &::after {
      content: "";
      position: absolute;
      left: 0px;
      top: 9px;
      width: 1px;
      height: 48px;
      background-color: #1890ff;
    }
    &:last-child {
      &::after {
        content: "";
        width: 0 !important;
        height: 0 !important;
      }
      .content {
        border-left: 0px solid rgba(216, 216, 216, 1);
        &::after {
          content: "";
          width: 0 !important;
          height: 0 !important;
        }
      }
    }
  }
  .introduction-version {
    padding: 0 20px;
    color: rgba(144, 147, 153, 1);
    height: 24px;
    line-height: 24px;
  }
  .content {
    margin: 5px 0;
    padding: 0 20px;
    color: #606266;
    word-break: break-all;
    border-left: 1px solid #1890ff;
    position: relative;
    line-height: 22px;
    &::after {
      content: "";
      position: absolute;
      left: -1px;
      bottom: -44px;
      width: 1px;
      height: 44px;
      background-color: #1890ff;
    }
  }
}
.loading {
  width: 20px;
  height: 20px;
  margin: 20px 0 20px 125px;
}
</style>
